import { useMemo } from "react";

import { coinSymbols } from "services/domain/coinSymbols";

import { usePrices } from "./usePrices";

export const useIncentivesData = () => {
  const prices = usePrices();
  const solUSD = prices[coinSymbols.SOL]?.usd ?? 0;
  const mndeUSD = prices[coinSymbols.MNDE]?.usd ?? 0;

  const incentivesStart = useMemo(
    () => new Date(Date.UTC(2024, 0, 1, 0, 0, 0)),
    []
  );

  const incentivesEnd = useMemo(
    () => new Date(Date.UTC(2024, 2, 31, 23, 59, 59)),
    []
  );

  const isIncentivesActive = useMemo(
    () =>
      incentivesStart.getTime() < Date.now() &&
      incentivesEnd.getTime() > Date.now(),
    [incentivesStart, incentivesEnd]
  );

  const incentivesAPY = useMemo(() => {
    const mndePerSolPerPeriod = 0.5;
    const timeDelta = incentivesEnd.getTime() - incentivesStart.getTime();
    const year = 365.25 * 24 * 60 * 60 * 1000;
    if (mndeUSD && solUSD && isIncentivesActive) {
      return (((mndePerSolPerPeriod * mndeUSD) / timeDelta) * year) / solUSD;
    }
    return 0;
  }, [incentivesEnd, incentivesStart, isIncentivesActive, mndeUSD, solUSD]);
  return {
    incentivesAPY,
    incentivesStart,
    incentivesEnd,
    isIncentivesActive,
  };
};
